import { IsString } from 'class-validator';

export class ChangeForgottenPasswordModel {
  @IsString()
  declare passwordSessionToken: string;

  @IsString()
  declare newPassword: string;
}
